import type { SVGProps } from 'react';

interface EggIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function EggIcon({ className, ...props }: EggIconProps) {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M6 16C4.4087 16 2.88258 15.3257 1.75736 14.1255C0.632141 12.9253 0 11.2974 0 9.6C0 6.0656 2.6865 0 6 0C9.3135 0 12 6.0656 12 9.6C12 11.2974 11.3679 12.9253 10.2426 14.1255C9.11742 15.3257 7.5913 16 6 16Z" fill="currentColor" />
    </svg>
  );
}
